/* src/app/shared/components/image-upload-hover/image-upload-hover.component.scss */
.image-container {
  width: 184px;
  height: 184px;
  border-radius: 4px;
  background-color: #f8f8f8;
  border: solid 1px #c8c7cc;
}
.image-container .image-exists {
  height: 100%;
  width: 100%;
  position: relative;
}
.image-container .image-exists:hover .change-image {
  opacity: 1;
  background-color: rgba(105, 105, 105, 0.9);
  transition: 0.3s all ease-in-out;
}
.image-container .image-exists img {
  object-fit: contain;
  width: 100%;
  height: 100%;
  vertical-align: middle;
}
.image-container .image-exists .change-image {
  opacity: 0;
  transition: 0.3s all ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.image-container .image-exists .change-image img {
  width: initial;
  height: initial;
}
.image-container .image-exists .change-image span {
  color: white;
}
.image-container button {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  transition: 0.5s all ease-in-out;
}
.image-container button:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transition: 0.5s all ease-in-out;
}
.image-container button img {
  width: initial;
  height: initial;
  margin-bottom: 8px;
}
.image-container button span {
  text-decoration: underline;
}
/*# sourceMappingURL=image-upload-hover.component.css.map */
